// Приглашения в кампанию.
// Вынесено из api.ts (Фаза 1, разбор клиента по доменам).

import { request } from "./client";
import { type Campaign } from "./campaign";
import { type CampaignStatus } from "./common";

export type CampaignInvitationStatus =
  "PENDING" | "ACCEPTED" | "DECLINED" | "CANCELLED";
export interface CampaignInvitation {
  id: string;
  campaignId: string;
  campaignTitle: string;
  campaignStatus: CampaignStatus;
  invitedUserId: string;
  invitedUserDisplayName: string;
  invitedUserUsername?: string;
  invitedByUserId: string;
  invitedByDisplayName: string;
  status: CampaignInvitationStatus;
  createdAt: string;
  respondedAt?: string;
}
export interface CampaignInviteCandidate {
  userId: string;
  displayName: string;
  username?: string;
  telegramUserId: number;
}

export const invitationApi = {
  incomingInvitations: () =>
    request<CampaignInvitation[]>("/api/campaigns/invitations"),
  inviteCandidates: (campaignId: string) =>
    request<CampaignInviteCandidate[]>(
      `/api/campaigns/${campaignId}/invite-candidates`,
    ),
  inviteCampaignUser: (campaignId: string, telegramUser: string) =>
    request<CampaignInvitation>(`/api/campaigns/${campaignId}/invitations`, {
      method: "POST",
      body: JSON.stringify({ telegramUser }),
    }),
  acceptCampaignInvitation: (invitationId: string) =>
    request<Campaign>(`/api/campaigns/invitations/${invitationId}/accept`, {
      method: "POST",
    }),
  declineCampaignInvitation: (invitationId: string) =>
    request<CampaignInvitation>(
      `/api/campaigns/invitations/${invitationId}/decline`,
      { method: "POST" },
    ),
};
